import React, { ErrorInfo } from 'react'
import Link from '../Atoms/Link'

export interface IErrorBoundaryState {
  hasError?: boolean
}

class ErrorBoundary extends React.Component<IErrorBoundaryState> {
  public static getDerivedStateFromError() {
    return { hasError: true }
  }
  public state: IErrorBoundaryState
  constructor(props: object) {
    super(props)
    this.state = { hasError: false }
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`Error: ${errorInfo}`)
  }
  public render() {
    const { hasError } = this.state
    if (hasError) {
      return (
        <>
          <h1>We're sorry</h1>
          <p>
            Something went wrong with this website. I'll get on a fix out as soon as possible.
          </p>
        </>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
